angular.module('mtic')
.service('ComponentIframeCom', function(
    $timeout,
    $rootScope,
    TIMING_CONSTANTS,
    EventManager,
    $log,
    $sce,
    language,
    volumeCaptionStatus,
    api,
    StudentDataService,
    LocaleService,
    FirebaseItematic,
    WindowOpener,
    apiMethods,
    userAccount,
    TeacherDataService,
    preliveCheck,
    PlatformService,
    cordovaMessenger,
    MapStateService,
    $location
){
    return function ComponentIframeCom(iframeId, scope, options) {
        options = options || {};
        var containerId = options.containerId || 'component-iframe-container';
        var windowId = options.windowId || null;
        var eventManager = new EventManager(iframeId, scope);
        var resourceState = {};
        var currentContent = {};
        var customVals = {};
        var currentIframe;
        var iframeLoaded = false;
        var curHostUrl = '';
        var lessonStarted = false;
        scope.volumeOn = true;
        scope.captionsOn = true;
        var noclass_items = [1236, 1240, 1244, 1248];
        /**
        * Broadcast to child iframe
        * @param  {String} type
        * @param {Object} payload
        * @return {null}
        */
        var broadcastToIframe = this.broadcastToIframe = function (type, payload) {
            if(!isExternalLink()) {
              $log.debug('[[ComponentIframeCom]]',type,payload);
              // $log.log('posting message : ', type, payload, document.getElementById(iframeId).src)
              currentIframe = document.getElementById(iframeId);
              document.getElementById(iframeId).contentWindow.postMessage(
                  JSON.stringify({
                      type: type,
                      payload: payload
                  }),
                  document.getElementById(iframeId).src
              )
            }else{
              $log.debug('[[ComponentIframeCom]] aborted sending `',type, payload, '` to frame, due to `custom_resource`')
            }
        }
        /**
         * @param  {String}
         */
        var startLoadingResource = this.startLoadingResource = function(slug, hostUrl, content){
          scope.notLoaded = true;
          //this flag is not used for anything
          if (content && content.container){
            scope.notLoaded = false;
          }
          resourceState = {};
          customVals = {};
          currentContent = content;
          //StudentDataService.getClassCommentState(scope.resource.id).then(function(states)
          reloadUrl(slug, hostUrl, content, false, function(){
            // if(currentContent.container === 'link' || currentContent.container === 'itematic_package') {
            if(currentContent && currentContent.container === 'link') {
              customVals.timeStart = Date.now();
              lesson_ended = false;
              customVals.working_session_hash = (Math.random().toString(26).substr(3,8) + userAccount.getData().sessionKey + Date.now())
              eventManager.broadcast(iframeId+':RESOURCE_LOAD_COMPLETE', {
                forced_by: currentContent.container
              });
              scope.notLoaded = false;
            }

          });
        }
        var reloadUrl = this.reloadUrl = function(slug, hostUrl, content, isGenNewWSHash, cb){
          if (isGenNewWSHash){
            customVals.working_session_hash = (Math.random().toString(26).substr(3,8) + userAccount.getData().sessionKey + Date.now());
          }
          withUrl(slug, hostUrl, content, function(url){
            if(isExternalLink()) {
              listenToExternalWindow(url);
              cb();
            }
            else{
              startIframe(url, cb, slug||"");
            }
          });
        }
        var withUrl = function(slug, hostUrl, content, cb){
          var url;
          // console.log('[[ASYNC ITEMATIC LOAD]] withUrl content', content);
          
          if (content && content.container === 'itematic_package'){
            // console.log('[[ASYNC ITEMATIC LOAD]]');
            var releaseTag = FirebaseItematic.getReleaseTagByQcStatus({
              isPrelive: preliveCheck.isPreliveCheck(),
              isQC: preliveCheck.isQCCheck()
            });
            FirebaseItematic.getItemUrl(content.itematicGroupId, content.itematicGroupItemId, releaseTag, function(url){
              cb(url);
            });
          }
          else if(!hostUrl) {
            cb(StudentDataService.genUrlfromContent(slug, content));
          }
          else if (hostUrl){
            cb(hostUrl);
          }
          else {
            throw new Error('No `hostUrl` passed into resource!');
          }
        }
        var currently_reporting = false;
        var lesson_ended = false;
        var last_working_session_hash;
        var reportProgress = function(stateUpdate){
          if(currently_reporting || (stateUpdate.complete && stateUpdate.working_session_hash && last_working_session_hash === stateUpdate.working_session_hash)){
            return;
          }
          if(!stateUpdate.complete && stateUpdate.score === 0){
            stateUpdate.score = null;
          }

          if(stateUpdate.app_state){
            stateUpdate.app_state.assessment_session_hash = eventManager.getResourceSession();
            // $log.log('got resource session : ' ,  stateUpdate.app_state.assessment_session_hash)
          }
          currently_reporting = stateUpdate.complete;
          return api.submitStudentResourceState(stateUpdate).then(function (response) {
              if(stateUpdate.complete && stateUpdate.working_session_hash){
                last_working_session_hash = stateUpdate.working_session_hash
              }
              currently_reporting = false;
              // $log.log('report progress sucess : ', stateUpdate, response)
              if(scope.resource.slug === 'mtic_teacher_offboarding'){
                //eventManager.broadcast('navbar:completed_test')
                eventManager.broadcast('notification-completed', 'teacher_questionnaire')
              }else if(scope.resource.slug === 'mtic_post_test'){
                LocaleService.done_student_post_test = true;
                eventManager.broadcast('C4_BASELINE_LOG', {
                  done_student_post_test: true
                })
              }else if(scope.resource.slug === 'mtic_student_offboarding'){
                LocaleService.done_student_offboarding = true;
                eventManager.broadcast('C4_BASELINE_LOG', {
                  done_student_offboarding: true
                })
              }
              if(stateUpdate.complete){
                lesson_ended = true;
                eventManager.broadcast('resource:score:submitted', {
                    "attemptNumber": response.attempts,
                    "work_batch_id": response.work_batch_id,
                    "score": stateUpdate.score,
                    "complete": stateUpdate.complete,
                    "slug": scope.resource.slug,
                    "component_instances": stateUpdate.component_instances || {},
                    "app_state": stateUpdate.app_state  || {},
                    "log_data": stateUpdate.log_data  || []
                })
                // eventManager.broadcast('module:close:resource', {isPassive:true});
                // eventManager.broadcast('app:module:refresh');
              }
          }, function (error) {
              $log.error('Failed to update the state', error)
              currently_reporting = false;
          })
        }

        var startIframe = function(hostUrl, cb, slug) {
          curHostUrl = hostUrl;
          var timer = TIMING_CONSTANTS.INSTANT;
          if(!currentIframe) {
            currentIframe = document.createElement('iframe')
            currentIframe.style.position = 'absolute';
            currentIframe.style.height = '100%';//slug.indexOf("mtic_g78_m0")>-1?"600px":'100%';
            currentIframe.style.width = '100%';
            currentIframe.style.position = 'absolute';
            currentIframe.style['padding-bottom'] = '0px'//(slug.indexOf("mtic_g78_m0")>-1 || slug.indexOf("mtic_g78_m4")>-1 )?'0px':'50px';
            //if(slug.indexOf("mtic_g78_m0")>-1 && (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent))){
              // $timeout(function(){
              //   currentIframe.style.transform = navigator.userAgent.match(/Android/i)? "scale(0.8)":"scale(0.9)";
              //   currentIframe.style.top = navigator.userAgent.match(/Android/i)? "-45px":"-30px";
              //   var parentElement = document.getElementById(iframeId).parentElement;
              //   parentElement.style.height = "600px";
              //   parentElement.style.width = "100%";
              //   parentElement.style.backgroundColor = "#fff";
              // },100);
            //}
            // currentIframe.style.transform = 'scale(1) !important';
            // currentIframe.style['-ms-transform'] = 'scale(1) !important';
            // currentIframe.style['-webkit-transform'] = 'scale(1) !important';
            // currentIframe.scrolling = options.scrolling || 'no';
            currentIframe.setAttribute('scrolling', options.scrolling || 'no')
            currentIframe.setAttribute('allow', 'autoplay');
            currentIframe.id = iframeId;
            var iframe_container = document.getElementById(containerId);
            iframe_container.appendChild(currentIframe);

            if(scope.resource.resource_type === 'embedded_notification'){
              currentIframe.style.position = 'relative';
              iframe_container.style.height = '100%';
              iframe_container.parentElement.style.height = '100%';
            }
            // if(noclass_items.indexOf(scope.resource.id) > -1){
            //   iframe_container.style['-webkit-overflow-scrolling'] = 'touch';
            //   iframe_container.style.position = 'fixed';
            //   iframe_container.style.width = '100%';
            //   iframe_container.style.height = '100%';
            // }
          }
          // else{
          //   timer = 200;
          // }
          // if(PlatformService.isAndroid || PlatformService.isIos){
          //   timer = 300;
          // }
          currentIframe.src = '';
          $timeout(function(){
            currentIframe.src = $sce.trustAsResourceUrl(hostUrl);

            $timeout(function(){
              if (cb)
              {
                cb();
              }
            }, TIMING_CONSTANTS.INSTANT)
          }, 300)

          return currentIframe;
        }

        var listenToExternalWindow = function(hostUrl) {
          var timer = WindowOpener.listenToWindowCloseOf(windowId, function(){
            eventManager.broadcast('module:close:resource');
          })
          scope.$on('$destroy', function(){
            if(timer){
              window.clearInterval(timer);
            }
          });
        }
        var isCustomResource = function(){
          return scope.resource.resource_type === 'custom_resource';
        }
        var isExternalLink = function() {
          return (scope.resource && scope.resource.content) ? scope.resource.content.container === 'link' : false;
        }
        scope.isCustomResource = isCustomResource;
        scope.isExternalLink = isExternalLink;
        /**
         * Convert all incoming messages from iframe to eventManager events
         */
        eventManager.listen('$messageIncoming', function (event, msgPayload) {
            // $log.log('$messageIncoming', {
            //     msgPayload: msgPayload,
            //     currentResource: scope.currentResource
            // })
            if (msgPayload.type) {
                var logEvent = msgPayload.payload;
                if(msgPayload.type === 'COMPONENT_LOG' && logEvent.eventName !== 'INIT') {
                    eventManager.itemBroadcast(
                        logEvent.componentId,
                        'COMPONENT_LOG',
                        logEvent
                    )
                }else if(msgPayload.type === 'GROUP_STATE_UPDATE') {
                    /*console.log('UPDATING RESOURCE STATE : ', scope.resource.id,
                        logEvent.componentId,
                        logEvent.eventData,
                        logEvent.timestamp)*/
                    api.updateClassComponentState(
                        scope.resource.id,
                        logEvent.componentId,
                        logEvent.eventData,
                        logEvent.timestamp
                    )
                }else{
                    eventManager.broadcast(iframeId+':' + msgPayload.type, logEvent)
                }
            } else {
                $log.error('No Event Type coming from resource!')
            }
        })
        /**
         * General Event Listeners
         */
        eventManager.listen('language:change', function (e, languageSlug) {
            broadcastToIframe('LANGUAGE_CHANGE', languageSlug)
        })
        eventManager.listen('navigation:volume:change', function (e, option) {
            broadcastToIframe('NAVIGATION_VOLUME_CHANGE', option)
        })
        eventManager.listen('navigation:captions:change', function (e, option) {
            broadcastToIframe('NAVIGATION_CAPTIONS_CHANGE', option)
        })
        var updateAndCloseDefer;
        eventManager.listen('module:updateAndClose:resource', function (e, defer) {
          if(updateAndCloseDefer){
            defer.reject();
          }
          if(!iframeLoaded){
            $timeout(function(){
              defer.resolve();
            },10);
          }
          else{
            updateAndCloseDefer = defer;
            broadcastToIframe('REQUEST_ITEM_APP_STATE_SAVE');
          }
        });

        eventManager.listen('module:close:resource', function(e, args ){
          api.postResourceTimeUpdate(customVals.working_session_hash);
          if(isExternalLink()) {
            var mod_id = scope.moduleId;
            reportProgress({
                "slug": scope.resource.slug,
                "score": 1,
                "complete": true,
                "time_spent": Date.now() - customVals.timeStart,
                "time_stamp": customVals.timeStart,
                "resource_id": scope.resource.id,
                "module_id": mod_id,
                "component_instances": {},
                "app_state": {},
                "log_data": {},
                "working_session_hash": customVals.working_session_hash
            })
          }
          if (args && args.isPassive){
            return;
          }
          // Need to change iFrame src before removing it, to make voices stop playing in ie11
          document.getElementById(iframeId).src = '';
          currentIframe = null;
          $rootScope.sender = null;
          if(isExternalLink()) {
            WindowOpener.close(windowId);
          }
        })
        eventManager.listen(iframeId+':RESOURCE_LOAD_COMPLETE', function (e, eventData) {
            lessonStarted = true;

            // $log.log('hostUrl: ', hostUrl)
            if(curHostUrl.indexOf('inbook') > -1 && window.location.href.indexOf('web-open-browser') === -1){
                // For inbook, there are 2 issues: 1) It creates a new history instance, which causes the back navigation to go back through that history instead of the browser
                // 2) the history entry is identical, which doesnt trigger onpopstate, thus the solution is to force
                // a new history entry htat is not identical(so we can trigger popstate) and then pop 3 history entries based on the 2 additional ones and the one we pushed
              window.onpopstate = function(event){
                window.history.go(-2);
              }

              $timeout(function(){
                window.history.pushState('', '', '?')
              }, 1000)
            }else if(location.href.indexOf('open_item_link') > -1) {
              $location.url('');
              LocaleService.item_link_opened = true;
            }

            scope.notLoaded = false;
            lesson_ended = false;
            customVals.timeStart = Date.now();
            customVals.working_session_hash = customVals.working_session_hash || (Math.random().toString(26).substr(3,8) + userAccount.getData().sessionKey + Date.now())
            broadcastToIframe('LANGUAGE_CHANGE', language.getCurrentSelectedLanguage())
            broadcastToIframe('NAVIGATION_VOLUME_CHANGE', volumeCaptionStatus.getVolume())
            broadcastToIframe('NAVIGATION_CAPTIONS_CHANGE', volumeCaptionStatus.getCaptions())
            broadcastToIframe('RESOURCE_DATA', {
              state: {frameCounter:0},
              states: resourceState,
              info: scope.resource,
              user: StudentDataService.getCurrentUserData()
            })

            resourceUnlocksAnother();

            var class_id;
            if(noclass_items.indexOf(scope.resource.id) > -1 || (!userAccount.getActiveClassData() && (!userAccount.getActiveClassroom() || userAccount.getActiveClassroom() === ''))){
              class_id = 99999;
              scope.moduleId = 57
            }else{
              class_id = userAccount.getData().role.isTeacher ? userAccount.getActiveClassData().id :  userAccount.getActiveClassroom()
            }
            api.initStateLogSession(StudentDataService.getCurrentUserData().user_id ,scope.resource.id, scope.moduleId || 57, class_id, customVals.working_session_hash, eventManager.getResourceSession()).then(function(state_log_data){
              // $log.log('got state log init data : ' , state_log_data)
            })

            var item_options = MapStateService.getItemOptions();
            if(item_options){
              $log.log('RESPONSE ITEM : ' , item_options)
              broadcastToIframe('SET_ITEM_OPTIONS', item_options);
              //MapStateService.setItemOptions(null);
            }

            api.getUserResourceLatestAppState(StudentDataService.getCurrentUserData().user_id ,scope.resource.id).then(function(data){
              window.console.log('GOT LATEST : ' , data, scope.resource)
              var latest_state_log = data.app_state || {};
              if(data.dependant_assessment_mapping){
                latest_state_log.dependant_assessment_mapping = data.dependant_assessment_mapping;
              }
              var maxScore = 0;
              if (scope.resource && scope.resource.resourceState){
                maxScore = scope.resource.resourceState.score_max
              }
              // window.console.log('scope.resource', maxScore);
              if(maxScore){
                var scoring = {score:maxScore}
                if(latest_state_log && latest_state_log.state_data && latest_state_log.state_data.highscores){
                  scoring.highscores = latest_state_log.state_data.highscores;
                }
                broadcastToIframe('LESSON_SCORE_RESTORE', scoring);
              }
              if(latest_state_log && (latest_state_log.state_data || latest_state_log.dependant_assessment_mapping)){
                broadcastToIframe('LESSON_STATE_RESTORE', latest_state_log)
              }
            })

            //focus on iframe so we don't need to click to get focus
            var cur_resource_frame = document.getElementById('mticResource')
            if(cur_resource_frame){
              cur_resource_frame.focus();
            }

            eventManager.broadcast('resource:load:complete');
        })

        function resourceUnlocksAnother(){
          if(userAccount.getData().role.role_type === 'mtic_student'){
            StudentDataService.getModuleData(false).then(function(data){
              // $log.log('module map data: ', data)
              var found = false;
              data.resources.forEach(function(cur_module){
                if(cur_module.id === scope.resource.parent_resource_id){
                  cur_module.children.forEach(function(resource){
                    if(resource.unlocked_by.indexOf(scope.resource.slug) > -1){
                      found = true;
                    }
                  })
                }
              })

              if(!found){
                broadcastToIframe('END_OF_MAP_ITEM', {unlocksNoItem:true})
              }
            })
          }else if(userAccount.getActiveClassroom()){
            TeacherDataService.getModuleMap(userAccount.getActiveClassroom()).then(function(data){
              // $log.log('module map data: ', data)
              var found = false;
              data.Modules.forEach(function(sub_mod){
                if(sub_mod.module_id === 2){
                  sub_mod.Resource.children.forEach(function(cur_module){
                    if(cur_module.id === scope.resource.parent_resource_id){
                      cur_module.children.forEach(function(resource){
                        if(resource.unlocked_by.indexOf(scope.resource.slug) > -1){
                          found = true;
                        }
                      })
                    }
                  })
                }
              })

              if(!found){
                broadcastToIframe('END_OF_MAP_ITEM', {unlocksNoItem:true})
              }
            })
          }
        }

        //object to report progress to serve
        var getStateUpdate = function(payload){
          if (payload.payload) {
            payload = payload.payload;
          }
          //hard coding the assessment module ids, since these can be opened under different module tabs
          var mod_id = scope.moduleId;
          // if(payload.slug === 'mtic_teacher_offboarding' || payload.slug === 'mtic_student_onboarding' || payload.slug === 'mtic_post_test' || payload.slug === 'mtic_baseline_assessment'){
          //   mod_id = 57;
          //   if(payload.slug === 'mtic_teacher_offboarding'){
          //     scope.classId = 99999;
          //   }
          // }

            var time_spent = Date.now() - customVals.timeStart;

            var score = payload.score;
            if(!score && score !== 0){
              score = (payload.completed || payload.complete) ? 1 : 0;
            }

            var complete_val = payload.completed;
            if(complete_val === null){
              complete_val = payload.complete;
            }

//            console.log('reporting from item progress: ', payload, time_spent, customVals.timeStart)
            var stateUpdate = {
                "slug": scope.resource.slug,
                "score": score,//Math.max(0,Math.min(1,score)),
                "complete": complete_val,
                "time_spent": time_spent,
                "time_stamp": customVals.timeStart,
                "resource_id": scope.resource.id,
                "module_id": mod_id || 57,
                "component_instances": payload.component_instances || {},
                "app_state": payload.app_state  || {},
                "log_data": payload.log_data || [],
                "working_session_hash": customVals.working_session_hash
            }
            // if(scope.classId) {
            //     stateUpdate.class_id = scope.classId;
            // }
            // if(mod_id === 28 || scope.resource.slug.indexOf('g78_m2') > -1){
            //   stateUpdate.complete = true;
            // }
            if(noclass_items.indexOf(scope.resource.id) > -1 || (!userAccount.getActiveClassData() && (!userAccount.getActiveClassroom() || userAccount.getActiveClassroom() === ''))){
              stateUpdate.class_id = 99999;
              scope.classId = 99999;
              scope.moduleId = 57
            }else{
              stateUpdate.class_id = userAccount.getData().role.isTeacher ? userAccount.getActiveClassData().id :  userAccount.getActiveClassroom();
            }

            return stateUpdate;
        }

        eventManager.listen(iframeId+':ITEM_PROGRESS', function (e, payload) {
          var stateUpdate = getStateUpdate(payload);
          // $log.log('stateUpdate: ', stateUpdate)
          reportProgress(stateUpdate)
        })

        eventManager.listen(iframeId+':LAB_AUTOSAVE', function (e, payload) {
          var stateUpdate = getStateUpdate(payload);
          api.submitStudentResourceState(stateUpdate).then(function (response) {
                // $log.log('autosave sucess : ', stateUpdate, response)
            }, function (error) {})
        });

        eventManager.listen(iframeId+':item-work-submission', function (e, payload) {
          // $log.log('mid-lesson item-work-submission : ', payload)
          payload.assessment_session_hash = eventManager.getResourceSession();
          var stateUpdate = {
                "slug": scope.resource.slug,
                "score": null,
                "complete": false,
                "time_spent": Date.now() - customVals.timeStart,
                "time_stamp": customVals.timeStart,
                "resource_id": scope.resource.id,
                "module_id": scope.moduleId,
                "app_state": payload,
                "log_data": [],
                "working_session_hash": customVals.working_session_hash
            }
          return api.submitStudentResourceState(stateUpdate).then(function (response) {
                // $log.log('report progress sucess : ', stateUpdate, response)
                broadcastToIframe('SUBMISSION_RESOLVED_'+payload.comm_id, {success:true, msg:'submitted work successfully'})
            }, function (error) {
                $log.error('Failed to update the state', error)
                broadcastToIframe('SUBMISSION_RESOLVED_'+payload.comm_id, {success:false, msg:'sumbmission failed'})
            })
        })

        eventManager.listen(iframeId+":RESPONSE_ITEM_APP_STATE_SAVE", function (e, payload) {
          var stateUpdate = getStateUpdate(payload);
          reportProgress(stateUpdate).then(function(){
            if(updateAndCloseDefer){
              iframeLoaded = false;
              updateAndCloseDefer.resolve();
              $timeout(function(){
                updateAndCloseDefer = null;
              },2000);
            }
          });
        });

        eventManager.listen(iframeId+":REQUEST_CLOSE", function (e, payload) {
          // $log.log("close resource");
        });

        eventManager.listen(iframeId+":OPEN_EXTERNAL_LINK", function (e, payload) {
          // $log.log("close resource");
          if (PlatformService.isApp){
            cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: payload.link_url });
          } else {
            window.open(payload.link_url ,'_blank');
          }
        });

        eventManager.listen(iframeId+":IDLE_TIME_RESET", function (e, payload) {
          eventManager.broadcast('iframe-idle-reset');
        });

        eventManager.listen(iframeId+":REQUEST_ITEM_APP_STATE", function (e, payload) {
          var user = StudentDataService.getCurrentUserData();
          iframeLoaded = true;
          broadcastToIframe("RESPONSE_GETTING_APP_STATE", null);
          //api.getUserResourceLastAppState(user.user_id,scope.resource.id).then(function(data){
          api.getUserResourceLatestAppState(user.user_id ,scope.resource.id).then(function(data){

            //this is to mitigate the change from lastappstate to latestappstate routes, as the first of those should be deprecated
            var constructed_response = [{
              WorkBatch:{
                StudentResourceStateLogs: data
              }
            }]

            // $log.log('RESPONSE_ITEM_APP_STATE', constructed_response)
            broadcastToIframe("RESPONSE_ITEM_APP_STATE",constructed_response);
          });
        });

        eventManager.listen('mouse:keyboard:active', function(e, args){
          if(lessonStarted && args && !args.idleInput && !lesson_ended && !args.returned_from_away){
            api.postResourceTimeUpdate(customVals.working_session_hash, true);
          }
        })

        eventManager.listen('browser:tab:beforeunload:shown', function(e){
          if(lessonStarted && !lesson_ended){
            api.postResourceTimeUpdate(customVals.working_session_hash, true);
            $rootScope.$digest();
          }
        })

        eventManager.listen('offline-post-call-resolved', function(){
          if(!lessonStarted){
            var temp = currentIframe.src;
            $log.log('GOT OFFLINE CALL RESOLVE FROM IFRAME', temp)
            currentIframe.src = '';
            $timeout(function(){
              currentIframe.src = $sce.trustAsResourceUrl(temp);
            }, 300)
          }
        });
    }
})
